import type { MessageKey } from '@components/support/ContactUs/Feedback'
import { validations } from '@utils/order'
export const NAME = 'cart.confirmation.billingName'
export const EMAIL = 'cart.confirmation.vendor.email.label'
export const PHONE = 'cart.confirmation.customerTelephone'
export const MESSAGE = 'wishlist.share.email.msg'
export const contactFormValidator = (key: MessageKey, value: string) => {
  if (key === NAME) {
    return !(value.trim().length < 2)
  }

  if (key === EMAIL) {
    return !!value && validations.email.test(value)
  }

  if (key === PHONE) {
    return !!value && validations.telephone.test(value)
  }

  if (key === MESSAGE) {
    return !(value.trim().length < 10)
  }
}
